// import { useState } from "react";
// import React from "react";
// import { imageCodes, textCodes, titleCodes, videoCodes } from "../../template_codes/asteria/about_page_codes";

// function About() {
//     const [showTab, setShowTab] = useState(false)
//     return (
//         <React.Fragment>
//             <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 font-quicksand pt-10">
//                 <div className="px-10">
//                     <h1 className="text-xl lg:text-4xl xl:text-4xl font-semibold pb-10">{titleCodes.aboutTitle.title}</h1>
//                     <p className="text-lg pt-2 lg:text-xl xl:text-xl text-justify">{textCodes.aboutus.text}</p>
//                 </div>
//                 <div className="px-2">
//                     <div className="pt-10 md:px-10 lg:pt-0 xl:pt-0">
//                         <img src={imageCodes.about.image}></img>
//                     </div>
//                 </div>
//             </div>

//             <div className="container w-full lg:w-3/5 xl:w-3/5 text-center pt-14">
//                 <div className="p-2">
//                     <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold">{titleCodes.mission.title}</h1>
//                     <p className="text-lg pt-2 lg:text-xl xl:text-xl">{textCodes.missionText.text}</p>
//                     <p className="pt-4">{textCodes.divider.text}</p>
//                 </div>

//                 <div className="p-2">
//                     <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold pt-4">{titleCodes.vision.title}</h1>
//                     <p className="text-lg pt-2 lg:text-xl xl:text-xl">{textCodes.visionText.text}</p>
//                     <p className="pt-4">{textCodes.divider.text}</p>
//                 </div>

//                 <div className="p-2">
//                     <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold pt-4">{titleCodes.value.title}</h1>
//                     <p className="text-lg pt-2 lg:text-xl xl:text-xl">{textCodes.valueText.text}</p>
//                     <p className="pt-4">{textCodes.divider.text}</p>
//                 </div>

//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 font-quicksand pt-14">
//                 <iframe src={videoCodes.video1.video} title="YouTube video player" frameborder="0" allow="accelerometer;
//                             autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
//                     className="w-96 h-60 md:w-full md:h-full lg:w-full lg:h-fix xl:w-5/6 xl:h-screen pl-2 xl:py-10 xl:pb-20 lg:ml-4 xl:ml-20"></iframe>
//                 <div className="p-10 md:pt-0 lg:pt-4 xl:pt-24">
//                     <h1 className="text-xl lg:text-2xl xl:text-2xl pb-10">{titleCodes.start.title}</h1>
//                     <h1 className="text-lg pt-2 lg:text-xl xl:text-xl leading-loose text-justify">{textCodes.aboutText.text}</h1>
//                 </div>
//             </div>
//         </React.Fragment>
//     );
// }

// export default About;

import { Container } from "@mantine/core";
import React from "react";

const AboutPage = () => {
  return (
    <div>
      <div className="flex">
        <div className="flex flex-col w-1/3">
          <div className="h-96">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FImage%20from%20iOS%20(2).jpg?alt=media&token=9126d138-c0f4-460d-97e8-30c70d92bdd3"
              alt=""
              className="h-96 w-auto object-cover object-center"
            />
          </div>
          <div className="h-96 flex flex-col justify-center items-center px-10 bg-gray-800 text-white">
            <h1 className="text-3xl">Vision</h1>
            <p className="mt-10 text-gray-400 tracking-wider leading-8">
              As an emerging local brand, we intend to provide all women with
              trendy designs and exceptional quality at reasonable prices.
            </p>
          </div>
          <div className="h-96">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fchoose_reason.jpg?alt=media&token=d9b54850-86c7-4475-9b47-3fa9f1aa9780"
              alt=""
              className="h-full w-full object-cover object-center"
            />
          </div>
          <div className="h-96 flex flex-col justify-center items-center px-10 bg-gray-800 text-white">
            <h1 className="text-3xl">Value</h1>
            <p className="mt-10 text-gray-400 tracking-wider leading-8">
              We focus on quality above quantity and functionality where all our
              products stick to both high and casual fashion which every women
              can style in every ways they want.
            </p>
          </div>
          <div className="h-96">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio6.jpg?alt=media&token=21a087f6-89b6-4336-9803-1398a4d5b694"
              alt=""
              className="h-full w-full object-cover object-center"
            />
          </div>
        </div>
        <div className="flex flex-col w-1/3">
          <div className="h-[30rem] flex flex-col justify-center items-center px-10 bg-[#CF8BA2] text-white">
            <h1 className="text-3xl">About Us</h1>
            <p className="mt-10 text-gray-200 tracking-wider leading-8">
              In Greek mythology, Asteria was the Titan goddess of shooting
              stars. She turned into a quail and fell into the Aegean to escape
              from Zeus. Our brand is formed by adopting the idea of her bravery
              to embrace the courage and confidence of women through fashion.
            </p>
          </div>
          <div className="bg-cyan-500 h-[30rem]">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio4.jpg?alt=media&token=39b94acf-3ce4-46ad-b81d-c78ef9ad2e53"
              alt=""
              className="h-full w-full object-center object-cover"
            />
          </div>
          <div className="flex flex-col justify-center items-center px-10 bg-[#CF8BA2] text-white h-[30rem]">
            <h1 className="text-3xl">
              🤎🤎Start the day with a cup of coffee and a nice outfit
            </h1>
            <p className="mt-10 text-gray-200 tracking-wider leading-8">
              Thank you to all our customers who have been supporting us since
              our first launch. We have donated our profit to those in needs.
              Thank you to everyone for trusting our brand and for your
              continuous love. We promise to come back even stronger with new
              designs and ideas.
            </p>
          </div>
          <div className="h-[30rem]">
            <iframe
              src="https://www.youtube.com/embed/Xbqd0mhRM2w"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
              className="h-full w-full object-cover object-center"
            ></iframe>
          </div>
        </div>
        <div className="flex flex-col w-1/3">
          <div className="h-[40rem]">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio14.jpg?alt=media&token=9e96a1e5-8338-478e-99e1-ff780b12fae3"
              alt=""
              className="h-full w-full object-center object-cover"
            />
          </div>
          <div className=" h-[40rem] flex flex-col justify-center items-center px-10 bg-gray-800 text-white">
            <h1 className="text-3xl">Mission</h1>
            <p className="mt-10 text-gray-400 tracking-wider leading-8">
              Our vision is to grow into the global fashion market as a Burmese
              brand showcasing local handiwork and new designs created straight
              out of Myanmar.
            </p>
          </div>
          <div className="h-[40rem]">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio13.jpg?alt=media&token=be2a75e0-c41f-4746-8307-4c41766d5118"
              alt=""
              className="h-full w-full object-center object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
